import React, { useState, useEffect, useRef, useContext } from "react";
import { translateCol } from "../../custom/columnI18n";

import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { AuthContext } from "../../Header/auth - context";
import { Button } from 'primereact/button';
import { MultiSelect } from 'primereact/multiselect';
import { Tooltip } from 'primereact/tooltip';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { useSelector } from 'react-redux';
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import handlePrint from './naloziStrane/putniNalogStampa';
import handlePrintWork from './naloziStrane/radniNalogStampa';
import handlePrintAgencijski from './naloziStrane/agencijskiNalogStampa';
import { confirmDialog } from 'primereact/confirmdialog';
import { Calendar } from 'primereact/calendar';
import { openSessionModal } from '../../store/sessionModalSlice';
import { useSessionHelper } from '../../custom/sessionHelper';
import { Checkbox } from 'primereact/checkbox';
import CustomDropdown from "../../custom/customDropdown";
import RadniNalog from "./radniNalog";
import useVisinaTabele from "../../custom/visinaTabele";

const TurePregled = (props) => {
  const { t } = useTranslation();

  const { sessionHelper } = useSessionHelper();
  const toast = useRef(null);
  const auth = useContext(AuthContext);
  const trip = useSelector(state => state.trip);
  const company = useSelector(state => state.company);
  const user = useSelector(state => state.user)
  const pagePregled = true;

  const [changeView, setChangeView] = useState(1);
  const activeClass = "activeButton";
  const [tableData, setTableData] = useState(null);
  const [tableDataWork, setTableDataWork] = useState(null);
  const [datumOd, setDatumOd] = useState(null);
  const [datumDo, setDatumDo] = useState(null);
  const [selectedRowId , setSelectedRowId] = useState(null);
  const [selectedRowIdWork , setSelectedRowIdWork] = useState(null);
  const getId = (row) => row?.ID ?? row?.id ?? row?.Izaberi ?? null; 
  const getIdWork = (row) => row?.ID ?? row?.id ?? row?.Izaberi ?? null;
  const isSelected = (row) => String(getId(row)) === String(selectedRowId);
  const isSelectedWork = (row) => String(getId(row)) === String(selectedRowIdWork);
  const [allColumns, setAllColumns] = useState([]);
  const [idWorkLog, setIDWorkLog] = useState(null);
  const [allColumnsWork, setAllColumnsWork] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [selectedColumnsWork, setSelectedColumnsWork] = useState([]);
  const [originalColumnOrder, setOriginalColumnOrder] = useState([]);
  const [originalColumnOrderWork, setOriginalColumnOrderWork] = useState([]);
  const [sviPutni, setSviPutni] = useState(false);
  const [sviRadni, setSviRadni] = useState(false);
  const [columnsTrip, setColumnsDBTrip] = useState([]);
  const [columnsTripWork, setColumnsDBTripWork] = useState([]);
  const [isLoadedConfigTrip, setIsLoadedConfigTrip] = useState(false);
  const [isLoadedConfigTripWork, setIsLoadedConfigTripWork] = useState(false);
  
  const tureSearchPutni = useSelector(state => state.tureSearchPutni);
  const tureSearchRadni = useSelector(state => state.tureSearchRadni);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [globalFilterWork, setGlobalFilterWork] = useState(null);
  /* Spisak se zavrsava na dnu ekrana; visina se MERI, ne pogadja. */
  const [omotPutni, visinaPutni, redovaPutni] = useVisinaTabele([selectedColumns, changeView]);

  /* DataTable primenjuje globalFilter kroz useUpdateEffect (PrimeReact #3819) koji se NE
     pokreće na inicijalni mount — zato početna vrednost mora stići kroz pravu state promenu
     POSLE mount-a (useEffect), ne kroz initialState u useState, inače input pokazuje tekst
     ali tabela ostaje neisfiltrirana */
  useEffect(() => {
    if (tureSearchPutni) setGlobalFilter(tureSearchPutni);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (tureSearchRadni) setGlobalFilterWork(tureSearchRadni);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  
  const [first, setFirst] = useState(0);
  /* Spisak se zavrsava na dnu ekrana; visina se MERI, ne pogadja. */
  const [omotRadni, visinaRadni, redovaRadni] = useVisinaTabele([tableDataWork, selectedColumnsWork, changeView]);
  const [firstWork, setFirstWork] = useState(0);
  const dispatch = useDispatch();


  //Za transfer
  const eskaliran = useSelector((state) => state.eskaliran);
  const userRole = useSelector((state) => state.user_role);
  const formRef = useRef(null);
  const [putniNaloziOptions, setPutniNaloziOptions] = useState([]);
  const [filteredPutniNaloziOptions, setFilteredPutniNaloziOptions] = useState([]);
  const [radniNaloziOptions, setRadniNaloziOptions] = useState([]);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    putniNalog: null,
    radniNalog: null
  });

  const resetData = () => {
      setFormData({
        putniNalog: null,
        radniNalog: null
      });

  }

  const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };
 
  const getConfigColumnsTrip = async () => {
    if(isLoadedConfigTrip) { 
      return columnsTrip
    } else {
      const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + auth.token,
    },
    body: JSON.stringify({
      /* 483 = „Pregled agencijski nalozi". Agencijski pregled ima 10 kolona
         vise, pa bi deljena konfiguracija (267) znacila da cuvanje izbora na
         jednom ekranu prepise izbor na drugom. */
      id_config: props.agencijski ? 483 : 267
    }),
  };

    const data = await fetch(process.env.REACT_APP_BACKEND_URL + "/config/", requestOptions)
      .then(handleErrors); 

    if (data.message) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: data.message,
        life: 3000,
      });
      setColumnsDBTrip({ empty: true, data: [] })
      return { empty: true, data: [] };
    }
     
    setIsLoadedConfigTrip(true)
    
    if(data.length > 0) {
                    setColumnsDBTrip({ empty: false, data: data })
                    return { empty: false, data: data };
                } else {
                    setColumnsDBTrip({ empty: true, data: [] })
                    return { empty: true, data: [] };
                }


    }
  
};
const getConfigColumnsWorkLog = async () => {
  if(isLoadedConfigTripWork) {
    return columnsTripWork
  } else {

  }
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + auth.token,
    },
    body: JSON.stringify({
      id_config: 268
    }),
  };

    const data = await fetch(process.env.REACT_APP_BACKEND_URL + "/config/", requestOptions)
      .then(handleErrors); 

    if (data.message) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: data.message,
        life: 3000,
      });
      setColumnsDBTripWork({ empty: true, data: [] })
      return { empty: true, data: [] };
    }

    setIsLoadedConfigTripWork(true)
    
    if(data.length > 0) {
                    setColumnsDBTripWork({ empty: false, data: data })
                    return { empty: false, data: data };
                } else {
                    setColumnsDBTripWork({ empty: true, data: [] })
                    return { empty: true, data: [] };
                }
};

  /* NAMERNO: ulazak na Pregled tura ponistava izabran putni nalog, da se
     uvek bira iznova iz tabele. Tabovi se renderuju uslovno, pa se ovaj
     pregled ponovo montira pri svakom povratku i efekat tada okine — to je
     zeljeno ponasanje, ne greska.

     Posledica koju treba znati: Obracun > Troskovi radi sa izabranim nalogom,
     pa se posle povratka na Pregled nalog mora izabrati ponovo. Bez izbora
     "Vozilo duzi" i "Vozac" nemaju sta da ponude — procedura ih puni iz
     naloga. Zato NE dodavati ovde preskakanje prvog prolaza. */
  useEffect(()=> {
    if(trip){
          dispatch({
            type: "TRIP",
            value: null
          });
          props.setIzabran(false)
          props.setIdTrip(null)
    }
    if(trip == null && props.idTrip != null) {
      props.setIdTrip(null)
    }
    props.isPage(pagePregled)
    document.title = `TMS`

  },[sviPutni])

  useEffect(() => {
    if(selectedRowId) {
            props.setIdTrip(null);
            props.setIzabran(false);
            dispatch({ type: "TRIP", value: null });
            setSelectedRowId(null)
    }


    let requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + auth.token,
      },
      body: JSON.stringify({
        sviPutni: sviPutni,
        /* Ista tabela, dve vrste naloga — server vraća samo traženu. */
        agencijski: props.agencijski ? 1 : 0
      }),
    };
    
    fetch(process.env.REACT_APP_BACKEND_URL + "/trip/returnAllDataTrips", requestOptions)
      .then(handleErrors)
      .then(async (data) => {
        setTableData(data);
        
        // Extract all available columns from the first data row
            if (data && data.length > 0) {
        const columns = Object.keys(data[0])
            .filter(key => !['ID'].includes(key))
            .map(key => ({
            label: key,
            value: key
            }));


          setAllColumns(columns);
          const originalOrder = Object.keys(data[0]);
          setOriginalColumnOrder(originalOrder);

              const columnsDB = await getConfigColumnsTrip();

              if (!columnsDB.empty && columnsDB.data.length > 0) {
                 let arr;

                  if(typeof columnsDB?.data?.[0]?.parametri === "string")
                  arr = JSON.parse(columnsDB.data[0].parametri);
                  else
                  arr = columnsDB.data[0].parametri;

                setSelectedColumns(arr);
              } else {
                setSelectedColumns(columns.slice(0, 5).map(col => col.value));
              }
        }
      })
      .catch((error) => {
        error.json().then((errorMessage) => {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: errorMessage.message,
            life: 3000,
          });
          console.log(errorMessage);
        });
      });
  }, [auth.token,company.companyId,props.resetOnSubmit, sviPutni, props.agencijski]);


  useEffect(()=>{
    
    if(idWorkLog || selectedRowIdWork) {
      setIDWorkLog(null)
      setSelectedRowIdWork(null)
    }

        let requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + auth.token,
      },
      body: JSON.stringify({
        sviRadni: sviRadni,
        /* Radni nalozi agencijskih naloga i tura se ne mesaju. */
        agencijski: props.agencijski ? 1 : 0
      }),
    };
    
      fetch(process.env.REACT_APP_BACKEND_URL + "/trip/returnAllDataWorkTrips", requestOptions)
      .then(handleErrors)
      .then(async (data) => {
        setTableDataWork(data);

            if (data && data.length > 0) {
        const columns = Object.keys(data[0])
            .filter(key => !['ID'].includes(key))
            .map(key => ({
            label: key,
            value: key
            }));
  
          
          setAllColumnsWork(columns);
          const originalOrder = Object.keys(data[0]);
          setOriginalColumnOrderWork(originalOrder);

          const columnsDBWorkLog = await getConfigColumnsWorkLog();

              if (!columnsDBWorkLog.empty && columnsDBWorkLog.data.length > 0) {
                let arr;

                  if(typeof columnsDBWorkLog?.data?.[0]?.parametri === "string")
                  arr = JSON.parse(columnsDBWorkLog.data[0].parametri);
                  else
                  arr = columnsDBWorkLog.data[0].parametri

                setSelectedColumnsWork(arr);
              } else {
                setSelectedColumnsWork(columns.slice(0, 5).map(col => col.value));
              }
        }
      })
      .catch((error) => {
        error.json().then((errorMessage) => {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: errorMessage.message,
            life: 3000,
          });
          console.log(errorMessage);
        });
      });
  },[auth.token,company.companyId,props.resetOnSubmit, sviRadni, props.agencijski])

      useEffect(()=>{
        
          if(!formSubmitted && changeView == 3) {
                  let requestOptions = {
                              method: "POST",
                              headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + auth.token,
                              },
                              /* Prebacivanje ide samo unutar iste vrste naloga:
                                 na agencijskom ekranu i spisak radnih i spisak
                                 ciljnih naloga su agencijski. */
                              body: JSON.stringify({ agencijski: props.agencijski ? 1 : 0 }),
                          };
                          fetch(process.env.REACT_APP_BACKEND_URL + "/trip/GetTripsForTransfer", requestOptions)
                              .then(handleErrors)
                              .then((data) => {
                                  const stringifiedJson = data[0][""];
                                  const parsedData = JSON.parse(stringifiedJson);
                                  /* `|| []` nije ukras: Dropdown sa `options=undefined`
                                     puca na `findSelectedOptionIndex` cim se otvori. */
                                  setPutniNaloziOptions(parsedData.PutniNaloziDB || [])
                                  setFilteredPutniNaloziOptions(parsedData.PutniNaloziDB || [])
                                  setRadniNaloziOptions(parsedData.RadniNaloziDB || [])
                                  
                              })
                              .catch((error) => {
                              error.json().then((errorMessage) => {
                                  toast.current.show({
                                  severity: "error",
                                  summary: "Error",
                                  detail: errorMessage.message,
                                  life: 3000,
                                  });
                                  console.log(errorMessage);
                              });
                              });
          }
    
      },[formSubmitted, changeView, props.agencijski])


  const chooseTrip = async (rowData) => {    
    const id = getId(rowData);

    let resultSession = await sessionHelper(user.userId,'PutniNalog', id)

    if(resultSession.zauzeto) {
                dispatch(openSessionModal({
                  type: "SESSION_LOCK",
                  message: resultSession.message
                }));
                return
    }

    document.title = `TMS - ${rowData["Broj naloga"] ?? rowData["Broj putnog naloga"]}`

    setSelectedRowId((prev) => {
      const next = String(prev) === String(id) ? null : String(id);

    if (next) {
      // selekcija
      const tripID = props.tripsDB?.find(t => String(t.ID) === String(rowData.Izaberi));
      if (tripID) {
        props.setIdTrip(tripID);
        props.setIzabran(true);
      }
      dispatch({ type: "TRIP", value: rowData.Izaberi });
    } else {
      // deselekcija
      props.setIdTrip(null);
      props.setIzabran(false);
      dispatch({ type: "TRIP", value: null });
    }

    return next;
  });

  }

  const chooseTripWork = (rowData) => {
      const id = getIdWork(rowData);
      setIDWorkLog(id);

    setSelectedRowIdWork((prev) => {
      const next = String(prev) === String(id) ? null : String(id);
    return next;
  });
}

   const previewBodyTemplate = (rowData, field) => {
    const filePathsString = rowData[field];
    if (!filePathsString) return '-';

    const selected = isSelected(rowData);
   
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <Button
              label='Izaberi'
              icon="pi pi-eye"
              className="p-button-text p-button-sm"
              onClick={(e) => chooseTrip(rowData)}
              tooltip="Izaberi putni nalog za dalji rad"
              tooltipOptions={{ position: 'top' }}
            />
          
      </div>
    );
  };

    const previewBodyTemplateWork = (rowData, field) => {
    const filePathsString = rowData[field];
    if (!filePathsString) return '-';
   
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <Button
              label='Izaberi'
              icon="pi pi-eye"
              className="p-button-text p-button-sm"
              onClick={(e) => chooseTripWork(rowData)}
              tooltip="Izaberi putni nalog za dalji rad"
              tooltipOptions={{ position: 'top' }}
            />
          
      </div>
    );
  };


  const isButtonColumn = (field) => {
    return field.startsWith('Izaberi') || 
           field.includes('File') || 
           field.includes('fajl') || 
           field.includes('upload') ||
           field.endsWith('LK') || // Lična karta
           field.endsWith('VD') || // Vozačka dozvola
           field.endsWith('PASS') || // Pasoš
           field.endsWith('VIZA') || // Viza
           field.includes('Dokument'); // Generic document
  };

const exportExcelWork = async () => {
    if (!selectedColumnsWork || selectedColumnsWork.length === 0) return;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('TURE');

    const headers = selectedColumnsWork.map(c => translateCol(t, c));

    // Add header row
    const headerRow = worksheet.addRow(headers);
    headerRow.font = { bold: true };
    headerRow.eachCell((cell) => {
        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFEFEFEF' }
        };
        cell.border = {
            top: { style: 'medium' },
            left: { style: 'medium' },
            bottom: { style: 'medium' },
            right: { style: 'medium' }
        };
    });

    // Add filtered data rows
    tableDataWork.forEach((rowData) => {
        const row = worksheet.addRow(headers.map(h => rowData[h] ?? ""));
        row.eachCell((cell) => {
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            };
        });
    });

    // Auto-size columns
    worksheet.columns.forEach((column, i) => {
        const lengths = [
            headers[i].length,
            ...tableData.map(row => (row[headers[i]] ?? "").toString().length)
        ];
        column.width = Math.max(...lengths) + 2;
    });

    // Serbian-formatted datetime
    const date = new Date();
    const options = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'Europe/Belgrade'
    };
    const serbianDateTime = date.toLocaleString('sr-RS', options)
        .replace(/\s/g, ' ')
        .replace(/,/g, '');

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, `Ture - Radni nalog - ${company.companyName} - ${serbianDateTime}.xlsx`);
};
const exportExcel = async () => {
    if (!selectedColumns || selectedColumns.length === 0) return;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('TURE');

    const headers = selectedColumns.map(c => translateCol(t, c));

    // Add header row
    const headerRow = worksheet.addRow(headers);
    headerRow.font = { bold: true };
    headerRow.eachCell((cell) => {
        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFEFEFEF' }
        };
        cell.border = {
            top: { style: 'medium' },
            left: { style: 'medium' },
            bottom: { style: 'medium' },
            right: { style: 'medium' }
        };
    });

    // Add filtered data rows
    tableData.forEach((rowData) => {
        const row = worksheet.addRow(headers.map(h => rowData[h] ?? ""));
        row.eachCell((cell) => {
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            };
        });
    });

    // Auto-size columns
    worksheet.columns.forEach((column, i) => {
        const lengths = [
            headers[i].length,
            ...tableData.map(row => (row[headers[i]] ?? "").toString().length)
        ];
        column.width = Math.max(...lengths) + 2;
    });

    // Serbian-formatted datetime
    const date = new Date();
    const options = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'Europe/Belgrade'
    };
    const serbianDateTime = date.toLocaleString('sr-RS', options)
        .replace(/\s/g, ' ')
        .replace(/,/g, '');

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, `Ture - Putni nalog - ${company.companyName} - ${serbianDateTime}.xlsx`);
};

const handlePrintServiceLog = () => {
    /* Agencijski nalog ide na SVOJ obrazac („Nalog za prevoz"). Obrazac putnog
       naloga je zvanični obrazac za teretno vozilo — vučno, prikolica, vozači i
       dozvole — a tu su naše vozilo i vozač, kojih kod agencijskog naloga nema,
       pa bi se odštampao prazan obrazac. */
    const jeAgencijski = !!props.agencijski;
    if(trip) {
      let requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + auth.token,
      },
      body: JSON.stringify({
        id: trip
      }),
    };
    
    fetch(process.env.REACT_APP_BACKEND_URL + (jeAgencijski ? "/trip/printAgencijskiNalog" : "/trip/printServiceLog"), requestOptions)
      .then(handleErrors)
      .then((data) => {
          if(data.message) {
             toast.current.show({
                                severity: "warn",
                                summary: data.message,
                                life: 3000,
                                });
            return
           }
        if(data){
          if(jeAgencijski) handlePrintAgencijski(data, t)
          else handlePrint(data)
        } 

      })
      .catch((error) => {
        error.json().then((errorMessage) => {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: errorMessage.message,
            life: 3000,
          });
          console.log(errorMessage);
        });
      });
    } else {
       toast.current.show({
            severity: "warn",
            summary: t('common.upozorenje'),
            detail: t(jeAgencijski ? 'ture.nijeIzabranAgencijskiZaStampu' : 'ture.nijeIzabranPutniZaStampu'),
            life: 3000,
          });
    }
}
const handlePrintServiceWorkLog = () => {
    if(idWorkLog) {
      let requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + auth.token,
      },
      body: JSON.stringify({
        id_work: idWorkLog
      }),
    };
    
    fetch(process.env.REACT_APP_BACKEND_URL + "/trip/printServiceWorkLog", requestOptions)
      .then(handleErrors)
      .then((data) => {
        
        
        if(data){
          handlePrintWork(data)
        } 

      })
      .catch((error) => {
        error.json().then((errorMessage) => {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: errorMessage.message,
            life: 3000,
          });
          console.log(errorMessage);
        });
      });
    } else {
       toast.current.show({
            severity: "warn",
            summary: "Upozorenje!",
            detail: "Niste izabrali radni nalog kako bi štampali!",
            life: 3000,
          });
    }
}

     const header = (
        <div className="export-buttons fakture-stavke-header">
            <div className="fakture-stavke-radnje">
              <Button type="button" icon="pi pi-file-excel" severity="success" rounded onClick={exportExcel} data-pr-tooltip="XLS" />
              <Button type="button" style={{marginLeft:'1%'}} icon="pi pi-print" severity="secondary" rounded onClick={handlePrintServiceLog} data-pr-tooltip="Print" />
            </div>
        </div>
    );
    const headerWork = (
        <div className="export-buttons fakture-stavke-header">
            <div className="fakture-stavke-radnje">
              <Button type="button" icon="pi pi-file-excel" severity="success" rounded onClick={exportExcelWork} data-pr-tooltip="XLS" />
              <Button type="button" style={{marginLeft:'1%'}} icon="pi pi-print" severity="secondary" rounded onClick={handlePrintServiceWorkLog} data-pr-tooltip="Print" />
            </div>
        </div>
    );

    const handleSaveConfigTrip = () => {
           confirmDialog({
                      message: "Jel ste sigurni da želite sačuvati konfiguraciju?",
                      acceptLabel: "Da",
                      rejectLabel: "Ne",
                      icon: "pi pi-info-circle",
                      acceptClassName: "p-button-danger",
                      accept: acceptInsertConfigTrip,
                      reject: rejectInsertConfigTrip,
                      });
    }
  
    const acceptInsertConfigTrip  = () => {
      if(selectedColumns.length > 0) {
         let requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth.token,
        },
        body: JSON.stringify({
          id_config: props.agencijski ? 483 : 267,
          parametri: selectedColumns
        }),
      };
      
      fetch(process.env.REACT_APP_BACKEND_URL + "/config/changeConfig", requestOptions)
        .then(handleErrors)
        .then((data) => {
  
  
            if(data.message && data.message == 'Nema izmena u podacima konfiguracije pregleda.'){
                  toast.current.show({
                      severity: "warn",
                      summary: "Upozorenje!",
                      detail: data.message,
                      life: 3000,
                      });
                  return
                  }  
                  setColumnsDBTrip({ empty: false, data: [{"parametri": selectedColumns}] })
              toast.current.show({
                  severity: "success",
                  summary: "Uspešna izmena konfiguracije pregleda za putne naloge!",
                  life: 3000,
              });
  
        })
        .catch((error) => {
          error.json().then((errorMessage) => {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: errorMessage.message,
              life: 3000,
            });
            console.log(errorMessage);
          });
        });
      } else {
          toast.current.show({
                      severity: "warn",
                      summary: "Upozorenje!",
                      detail: "Morate imati barem 1 izabranu stavku!",
                      life: 3000,
                      });
      }
       
    }
    const rejectInsertConfigTrip = () => {
      console.log('Config insert rejected!')
    }
  
      const handleSaveConfigWorkLog = () => {
             confirmDialog({
                        message: "Jel ste sigurni da želite sačuvati konfiguraciju?",
                        acceptLabel: "Da",
                        rejectLabel: "Ne",
                        icon: "pi pi-info-circle",
                        acceptClassName: "p-button-danger",
                        accept: acceptInsertConfigWorkLog,
                        reject: rejectInsertConfigWorkLog,
                        });
      }
    
      const acceptInsertConfigWorkLog  = () => {
        if(selectedColumns.length > 0) {
           let requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + auth.token,
          },
          body: JSON.stringify({
            id_config: 268,
            parametri: selectedColumnsWork
          }),
        };
        
        fetch(process.env.REACT_APP_BACKEND_URL + "/config/changeConfig", requestOptions)
          .then(handleErrors)
          .then((data) => {
    
    
              if(data.message && data.message == 'Nema izmena u podacima konfiguracije pregleda.'){
                    toast.current.show({
                        severity: "warn",
                        summary: "Upozorenje!",
                        detail: data.message,
                        life: 3000,
                        });
                    return
                    }  
                  setColumnsDBTripWork({ empty: false, data: [{"parametri": selectedColumnsWork}]  })
                toast.current.show({
                    severity: "success",
                    summary: "Uspešna izmena konfiguracije pregleda za radne naloge!",
                    life: 3000,
                });
    
          })
          .catch((error) => {
            error.json().then((errorMessage) => {
              toast.current.show({
                severity: "error",
                summary: "Error",
                detail: errorMessage.message,
                life: 3000,
              });
              console.log(errorMessage);
            });
          });
        } else {
            toast.current.show({
                        severity: "warn",
                        summary: "Upozorenje!",
                        detail: "Morate imati barem 1 izabranu stavku!",
                        life: 3000,
                        });
        }
         
      }
      const rejectInsertConfigWorkLog = () => {
        console.log('Config insert rejected!')
      }
    
    const filteredData = tableData?.filter(item => {
      const datumString = item["Datum polaska"];

      if (!datumString) return false; // zaštita

      // Pretvori "10.09.2025" → Date objekt
      const [day, month, year] = datumString.split(".");
      const datum = new Date(`${year}-${month}-${day}`);

      if (datumOd && datum < datumOd) return false;
      if (datumDo && datum > datumDo) return false;

      return true;
    });

      const invalidControl = (data) => {
    if (!formSubmitted) return false; // ← NE prikazuj grešku dok forma nije poslata

    if (data && data != null && !Number(data)) {
      return data.length > 0 ? false : true;
    } else if (data != null && Number(data)) {
      return false;
    }
    return true;
  };

    const handleChange = (e, index) => {
    const { name, value } = e.target || e; // ako Dropdown šalje samo value

    if (name in formData) {

            if(name == 'radniNalog' && formData.putniNalog)
              setFormData((prev) => ({ ...prev, putniNalog: null }));

            if(name == 'radniNalog'){
              let pNalog = radniNaloziOptions.find(x=>x.value == value)
              setFilteredPutniNaloziOptions(putniNaloziOptions.filter(x=>x.value != pNalog.id_putni_nalog))
            }

      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

     const handleFormSubmit = (e) => {
  
                       e.preventDefault(); // bitno da ne submituje bez validacije
                  setFormSubmitted(true)
              if (formRef.current && !formRef.current.checkValidity()) {
                  formRef.current.reportValidity(); // prikazuje native browser poruke
                  return;
              }
      handleUploadAndSave()
   }

             const handleUploadAndSave = () => {
            
                 confirmDialog({
                 message: "Jel ste sigurni da želite nastaviti sa prebacivanjem?",
                 acceptLabel: "Da",
                 rejectLabel: "Ne",
                 icon: "pi pi-info-circle",
                 acceptClassName: "p-button-danger",
                 accept: acceptInsert,
                 reject: rejectInsert,
                 });
             
     
         };

        const acceptInsert = async () => {

                  const hasAnyValue = Object.values(formData).some(value => {
                  if (value === null || value === '') return false;
  
                  // Check if it's a valid Date object
                  if (value instanceof Date && isNaN(value.getTime())) return false;
  
                  return true;
                  });
                  const payload = {
                        ...formData
                        };

                  if(hasAnyValue){
                      
                            let requestOptions = {
                              method: "POST",
                              headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + auth.token,
                              },
                              body: JSON.stringify({
                                  formData: payload
                              }),
                          };
                         
                          await fetch(process.env.REACT_APP_BACKEND_URL + "/trip/transferWorkLog", requestOptions)
                              .then(handleErrors)
                              .then((data) => {
  
                                      if(data[0]?.message && data[0]?.message != 'Uspešno prebacivanje radnog naloga!'){
                                      toast.current.show({
                                      severity: "warn",
                                      summary: "Upozorenje!",
                                      detail: data[0]?.message,
                                      life: 3000,
                                      });
                                      return
                                    }
                          
                                  resetData()
                                  setFormSubmitted(false)
  
                                 toast.current.show({
                                  severity: "success",
                                  summary: "Uspešno!",
                                  detail: "Uspešno prebacivanje radnog naloga!",
                                  life: 3000,
                                  });

                              })
                              .catch((error) => {
                              if (error instanceof Response) {
                                  error.json().then((errorMessage) => {
                                      toast.current.show({
                                      severity: "error",
                                      summary: "Error",
                                      detail: errorMessage.message,
                                      life: 3000,
                                      });
                                      console.log(errorMessage);
                                  });
                              } else {
                                  toast.current.show({
                                  severity: "error",
                                  summary: "Error",
                                  detail: error.message || "Greška prilikom prebacivanja radnog naloga!",
                                  life: 3000,
                                  });
                                  console.log(error);
                              }
                              });
                  } else {
                          toast.current.show({
                          severity: "warn",
                          summary: "Upozorenje!",
                          detail: "Niste popunili podatke za prebacivanje!",
                          life: 3000,
                      });
            }
  
    };
      const rejectInsert = () => {
      console.log("Odbijen prebačaj podataka!");
    };    

  return (
    <>
    <div className="zaposleni_table_container" style={{maxHeight: '10vh',marginBottom:'0 !important'}}>
          <Button
            id={changeView == 1 && activeClass}
            /* Prvi tab u pregledu je ono sto se bira i kasnije edituje. Kod
               agencijskog modula to su agencijski nalozi — tabela je ista, ali
               `props.agencijski` filtrira `jeAgencijski = 1`, pa bi natpis
               „Putni nalozi" govorio da se bira nesto drugo nego sto je u listi. */
            label={t(props.agencijski ? 'ture.agencijskiNaloziBtn' : 'ture.putniNaloziBtn')}
            className="mt-3 zaposleniShift marginLeftNone"
            onClick={() => {
              setChangeView(1);
            }}
          />
          <Button
            id={changeView == 2 && activeClass}
            label={t('ture.radniNaloziBtn')}
            style={{marginTop:"1%"}}
            className="mt-3 zaposleniShift"
            onClick={() => {
              setChangeView(2);
            }}
          />
          <Button
            id={changeView == 3 && activeClass}
            label={t('ture.prebaciNalogBtn')}
            style={{marginTop:"1%"}}
            className="mt-3 zaposleniShift"
            onClick={() => {
              setChangeView(3);
            }}
          />
      </div>
        {changeView== 1 &&
    <div className="zaposleni_table_container" style={{marginBottom:'1%'}}>
      <Toast ref={toast} />
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "1em" }}>
        <div style={{ width: "20%" }}>
          {allColumns.length > 0 && (
            <div style={{display:'flex', alignItems:'center', justifyContent:'center'}}>  <MultiSelect
              value={selectedColumns}
              options={allColumns}
              onChange={(e) => {
  const sorted = originalColumnOrder.filter((key) => e.value.includes(key));
  setSelectedColumns(sorted);
}}
              optionLabel="label"
              display="chip"
              placeholder={t('nova.odaberiteKolone')}
              style={{ width: '100%' }}
              showSelectAll={true}
              filter
              filterPlaceholder="Pretraži kolone"
              maxSelectedLabels={3}
              selectedItemsLabel="{0} kolona odabrano"
            /><button onClick={handleSaveConfigTrip} style={{marginLeft:'1%'}} className="configSaveButton"><i className="pi pi-save"></i></button></div>
          )}
        </div>
        <div style={{minWidth:'70%', display:'flex', justifyContent:'flex-end'}}>
          <div style={{height:'100%', display:'flex', justifyContent: 'center', alignItems:'center',minWidth: '5%'}}>
            <Checkbox 
            id="sviPutni" 
            name="sviPutni" 
            checked={sviPutni} 
            onChange={(e)=>(setSviPutni(e.target.checked),props.setSviPutni(e.target.checked))} 
            tooltip="SVI PUTNI NALOZI"
            tooltipOptions={{ position: 'top' }}
          />
          </div>
          <Calendar
            value={datumOd}
            onChange={(e) => setDatumOd(e.value)}
            placeholder={t('ture.phDatumOd')}
            dateFormat="dd.mm.yy"
            showIcon
            mask="99.99.9999"
            style={{marginRight:'1%', maxWidth:'15%'}}
          />

          <Calendar
            value={datumDo}
            onChange={(e) => setDatumDo(e.value)}
            placeholder={t('ture.phDatumDo')}
            dateFormat="dd.mm.yy"
            showIcon
            mask="99.99.9999"
            style={{marginRight:'1%', maxWidth:'15%'}}
          />
          <input
            type="search"
            value={globalFilter || ''}
            onInput={(e) => { setGlobalFilter(e.target.value); dispatch({ type: 'TURE_SEARCH_PUTNI', value: e.target.value }); }}
            onChange={() => {}}
            placeholder={t('nova.phPretraga')}
            className="p-inputtext p-component"
          />
        </div>
      </div>

      <Tooltip target=".export-buttons>button" position="bottom" />
      <div ref={omotPutni}>
      <DataTable
        paginator
        rows={redovaPutni}
        value={filteredData}
        first={first}
        globalFilter={globalFilter}
        onPage={(e) => setFirst(e.first)}
        scrollable
        header={header}
        scrollHeight={visinaPutni}
        emptyMessage={t('common.noDataTable')}
        loading={tableData === null}
        resizableColumns
        className="turePregledTable stavke-tabela"
        columnResizeMode="expand"
        rowClassName={(data) => (isSelected(data) ? "selected-row" : "")}
      >
        {selectedColumns.map((colKey) => {
        const colMeta = allColumns.find(col => col.value === colKey);
        return (
          <Column
            key={colKey}
            field={colKey}
            header={translateCol(t, colMeta?.label || colKey)}
            sortable
            body={(rowData) => {
              if (isButtonColumn(colKey)) {
                return previewBodyTemplate(rowData, colKey);
              }
              if (colKey === 'Relacija') {
                return <div className={`relacija-cell${isSelected(rowData) ? ' expanded' : ''}`}>{rowData[colKey] || '-'}</div>;
              }
              return rowData[colKey] || '-';
            }}
            style={{ minWidth: '150px'}}
          />
        );
      })}
      </DataTable>
      </div>
    </div>}
    {changeView== 2 &&
    <div className="zaposleni_table_container" style={{marginBottom:'1%'}}>
      <Toast ref={toast} />
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "1em" }}>
        <div style={{ width: "20%" }}>
          {allColumnsWork.length > 0 && (
            <div style={{display:'flex', alignItems:'center', justifyContent:'center'}}>  <MultiSelect
              value={selectedColumnsWork}
              options={allColumnsWork}
              onChange={(e) => {
  const sorted = originalColumnOrderWork.filter((key) => e.value.includes(key));
  setSelectedColumnsWork(sorted);
}}
              optionLabel="label"
              display="chip"
              placeholder={t('nova.odaberiteKolone')}
              style={{ width: '100%' }}
              showSelectAll={true}
              filter
              filterPlaceholder="Pretraži kolone"
              maxSelectedLabels={3}
              selectedItemsLabel="{0} kolona odabrano"
            /> <button onClick={handleSaveConfigWorkLog} style={{marginLeft:'1%'}} className="configSaveButton"><i className="pi pi-save"></i></button></div>
          )}
        </div>
        <div style={{minWidth:'70%', display:'flex', justifyContent:'flex-end'}}>
            <div style={{height:'100%', display:'flex', justifyContent: 'center', alignItems:'center',minWidth: '5%'}}>
             <Checkbox 
            id="sviRadni" 
            name="sviRadni" 
            checked={sviRadni} 
            onChange={(e)=>setSviRadni(e.target.checked)}  
            tooltip="SVI RADNI NALOZI"
            tooltipOptions={{ position: 'top' }}
          />
          </div>
          <input
            type="search"
            value={globalFilterWork || ''}
            onInput={(e) => { setGlobalFilterWork(e.target.value); dispatch({ type: 'TURE_SEARCH_RADNI', value: e.target.value }); }}
            onChange={() => {}}
            placeholder={t('nova.phPretraga')}
            className="p-inputtext p-component"
          />
        </div>
      </div>

      <Tooltip target=".export-buttons>button" position="bottom" />
      <div ref={omotRadni}>
      <DataTable
        value={tableDataWork}
        paginator
        rows={redovaRadni}
        first={firstWork}
        globalFilter={globalFilterWork}
        onPage={(e) => setFirstWork(e.first)}
        scrollable
        header={headerWork}
        scrollHeight={visinaRadni}
        emptyMessage={t('common.noDataTable')}
        loading={tableDataWork === null}
        resizableColumns
        className="turePregledTable stavke-tabela"
        columnResizeMode="expand"
        rowClassName={(data) => (isSelectedWork(data) ? "selected-row" : "")}
      >
        {selectedColumnsWork.map((colKey) => {
        const colMeta = allColumnsWork.find(col => col.value === colKey);
        return (
          <Column
            key={colKey}
            field={colKey}
            header={translateCol(t, colMeta?.label || colKey)}
            sortable
            body={(rowData) => {
              if (isButtonColumn(colKey)) {
                return previewBodyTemplateWork(rowData, colKey);
              }
              if (colKey === 'Relacija' || colKey === 'Utovari' || colKey === 'Istovari') {
                return <div className={`relacija-cell${isSelectedWork(rowData) ? ' expanded' : ''}`}>{rowData[colKey] || '-'}</div>;
              }
              return rowData[colKey] || '-';
            }}
            style={{ minWidth: '150px'}}
          />
        );
      })}
      </DataTable>
      </div>
    </div>}
    {changeView == 3 && <form autoComplete="off" ref={formRef}> <Toast ref={toast} /> <div className="gridLicni gridRadniNaloziFakture zaposleni_table_container" style={{alignItems: 'flex-end'}}>
                <div className="col-12 md:col-6">
                <label htmlFor="radniNalog">{t('ture.radniNalogTransfer')}:</label>
                <CustomDropdown
                  id="radniNalog"
                  name="radniNalog"
                  required
                  invalid={invalidControl(formData.radniNalog)}
                  value={formData.radniNalog}
                  options={radniNaloziOptions}
                  placeholder={t('ture.phRadniNalog')}
                  onChange={handleChange}
                  optionLabel="label"
                />
              </div>
              <div className="col-12 md:col-6">
                <label htmlFor="putniNalog">{t(props.agencijski ? 'ture.agencijskomPrebacuje' : 'ture.putniNaloguPrebacuje')}:</label>
                <CustomDropdown
                  id="putniNalog"
                  name="putniNalog"
                  required
                  invalid={invalidControl(formData.putniNalog)}
                  value={formData.putniNalog}
                  options={filteredPutniNaloziOptions}
                  placeholder={t('ture.phPutniNalog')}
                  onChange={handleChange}
                  optionLabel="label"
                />
              </div>
          <Button label={t('ture.prebaci')} type="submit" severity="success" className="mt-3" style={{width: 'max-content', minWidth:'150px', maxHeight:'fit-content'}} onClick={handleFormSubmit} />
          
</div></form> }
   </>
  );
};

export default TurePregled;